import { useEffect, useState } from 'react';
import { FormatFloatAsDollarAmount } from '../universal/InternalCalculator'
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Checkbox
} from '@mui/material';
import { SelectAllFromTable, SelectGenericFromTable } from '../universal/Axios';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'

const store = getStore();

const CreateGenAlgRun = () => {
    const [genAlgRunID, setGenAlgRunID] = useState("")
    const [description, setDescription] = useState("")
    const [parameterSetID, setParameterSetID] = useState("")
    const [parameterSetIDs, setParameterSetIDs] = useState([])
    const [persisterConfigID, setPersisterConfigID] = useState("")
    const [persisterConfigOptions, setPersisterConfigOptions] = useState([])
    const [baseDncID, setBaseDncConfigID] = useState("")
    const [dncIDs, setDncIDs] = useState([])
    const [comparativeSetID, setComparativeSetID] = useState(undefined)
    const [comparativeSetIDs, setComparativeSetIDs] = useState([])
    const [genAlgSelectionConfigID, setGenAlgSelectionConfigID] = useState("")
    const [genAlgSelectionConfigIDs, setGenAlgSelectionConfigIDs] = useState("")
    const [maxGenerationCount, setMaxGenerationCount] = useState("")
    const [autoRun, setAutoRun] = useState(false)
    const [useWilcoxon, setUseWilcoxon] = useState(false)
    const [wilcoxonMetric, setWilcoxonMetric] = useState(false)
    const [errors, setErrors] = useState([])
    const [costEstimateMin, setCostEstimateMin] = useState("")
    const [costEstimateMax, setCostEstimateMax] = useState("")
    const maxGenerationCountErrorText = "Max Generation Count must be a non-negative integer no greater than 20."

    const persisterConfigIDs = ["Channel_Resonator_Waveforms_Only", "Speech_Signal_Absorption_Time_Series", "More_Harmonics_Speech_Signal_Absorption_Time_Series", "N_Audio_Full_Transmitting_1_Adjacent"]
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    useEffect(() => {
        SelectGenericFromTable('SELECT cs.id, count(*) FROM comparative_set cs JOIN comparative_set_snsi_mapping cssm ON cs.id = cssm.comparative_set_id GROUP BY cs.id', setComparativeSetIDs)
        SelectGenericFromTable("select * from density_network_config where is_gen_alg_generated = 0 order by id;", setDncIDs)
        SelectAllFromTable('parameter_set', setParameterSetIDs)
        SelectAllFromTable('gen_alg_selection_config', setGenAlgSelectionConfigIDs)
        SelectGenericFromTable("SELECT * FROM persister_config WHERE id IN ('" + persisterConfigIDs.join("','") + "');", setPersisterConfigOptions)
    }, [])

    useEffect(() => {
        if (genAlgRunID !== "" && comparativeSetID && comparativeSetID.length > 0) {
            setSubmitButtonDisabled(false)
        }
        else {
            setSubmitButtonDisabled(true)
        }
    }, [genAlgRunID, comparativeSetID]);

    useEffect(() => {
        if (persisterConfigID !== "" && comparativeSetID !== "" && maxGenerationCount !== "") {
            console.log(persisterConfigOptions.find(x => x.id === persisterConfigID))
            setCostEstimateMin(persisterConfigOptions.find(x => x.id === persisterConfigID).min_cost_estimate * maxGenerationCount * 10)
            setCostEstimateMax(persisterConfigOptions.find(x => x.id === persisterConfigID).max_cost_estimate * maxGenerationCount * 10)
        }
    }, [persisterConfigID, maxGenerationCount, comparativeSetID])

    const createGenAlgRun = () => {
        store.updateStatusMessage("Creating gen alg run...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Initialize_Genetic_Algorithm_Run",
                "id": genAlgRunID,
                "description": description,
                "base_dnc_id": baseDncID,
                "parameter_set_id": parameterSetID,
                "persister_config_id": persisterConfigID,
                "partial_comparative_set_id": comparativeSetID,
                "is_compare_all_generations": "1",
                "gen_alg_selection_config_id": genAlgSelectionConfigID == "" ? null : genAlgSelectionConfigID,
                "max_generation_count": maxGenerationCount,
                "is_auto_run": autoRun ? "1" : "0",
                "use_wilcoxon": useWilcoxon ? "1" : "0",
                "wilcoxon_metric": wilcoxonMetric
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully generated gen alg run!")
            //window.location.href = "/edit-gen-alg-run?id=" + genAlgRunID
            window.location.href = "/gen-alg-runs"
        }).catch(function (error) {
            store.updateStatusMessage("Gen alg run creation failed")
            console.log(error)
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    useEffect(() => {
        var n = Math.floor(Number(maxGenerationCount));

        if (String(n) === maxGenerationCount && n >= 0 && n <= 20) {
            setErrors(errors => errors.filter(x => x !== maxGenerationCountErrorText))
        }
        else if (!errors.includes(maxGenerationCountErrorText)) {
            setErrors(errors => errors.concat([maxGenerationCountErrorText]))
        }
    }, [maxGenerationCount])

    return (
        <Box>
            <Typography variant="h5">Create Gen Alg Run</Typography>
            {errors.map(x => <div style={{ color: "red" }}>{x}</div>)}

            <Box sx={{ height: costEstimateMin !== "" && costEstimateMax !== "" ? '20px' : '0px', color: "#eb9834", marginTop: '10px' }}>
                {costEstimateMin && <><span style={{ color: "#eb9834" }}>Cost Estimate: {FormatFloatAsDollarAmount(costEstimateMin)} &lt; X &lt;  {FormatFloatAsDollarAmount(costEstimateMax)}</span> </>}

            </Box>
            <Box sx={{ height: '40px', marginTop: '10px' }}>
                <Checkbox
                    checked={autoRun}
                    onClick={() => setAutoRun(!autoRun)}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28, marginTop: '-5px' } }}
                />  <span style={{ width: '45%', fontSize: '1.3rem' }}>Auto Run </span>
                <Checkbox
                    checked={useWilcoxon}
                    onClick={() => setUseWilcoxon(!useWilcoxon)}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 28, marginTop: '-5px' } }}
                />  <span style={{ width: '45%', fontSize: '1.3rem' }}>Use Wilcoxon</span>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginTop: '25px', marginRight: '20px' }}>
                    <TextField
                        id="id"
                        label="Gen Alg Run ID"
                        onChange={(event) => setGenAlgRunID(event.target.value)}
                        required
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '45%', marginTop: '25px' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setDescription(event.target.value)}
                        defaultValue={description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginTop: '25px', marginRight: '20px' }}>
                    <InputLabel id="parameter_set_id">Parameter Set ID</InputLabel>
                    <Select
                        id="parameter_set_id"
                        label="Parameter Set ID"
                        value={parameterSetID}
                        variant="outlined"
                        onChange={(event) => setParameterSetID(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {parameterSetIDs && parameterSetIDs?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.id}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl style={{ width: '45%', marginTop: '20px' }}>
                    <InputLabel id="base_dnc_id">Base Density Network Config ID</InputLabel>
                    <Select
                        id="base_dnc_id"
                        label="Base Density Network Config ID"
                        value={baseDncID}
                        variant="outlined"
                        onChange={(event) => setBaseDncConfigID(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {dncIDs && dncIDs?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.id}</MenuItem>)}
                    </Select>
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginTop: '20px', marginRight: '20px' }}>
                    <InputLabel id="comparative_set_id">Comparative Set ID</InputLabel>
                    <Select
                        id="comparative_set_id"
                        label="Comparative Set ID"
                        value={comparativeSetID}
                        variant="outlined"
                        onChange={(event) => setComparativeSetID(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {comparativeSetIDs && comparativeSetIDs?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.id}</MenuItem>)}
                    </Select>
                </FormControl>
                {!useWilcoxon && <FormControl style={{ width: '45%', marginTop: '20px' }}>
                    <InputLabel id="gen_alg_selection_config_id">Selection Config ID</InputLabel>
                    <Select
                        id="gen_alg_selection_config_id"
                        label="Selection Config ID"
                        value={genAlgSelectionConfigID}
                        variant="outlined"
                        onChange={(event) => setGenAlgSelectionConfigID(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {genAlgSelectionConfigIDs && genAlgSelectionConfigIDs?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.id}</MenuItem>)}
                    </Select>
                </FormControl>}
                {useWilcoxon && <FormControl style={{ width: '45%', marginTop: '20px' }}>
                    <InputLabel id="wilcoxon_metric">Wilcoxon Metric</InputLabel>
                    <Select
                        id="wilcoxon_metric"
                        label="Wilcoxon Metric"
                        value={wilcoxonMetric}
                        variant="outlined"
                        onChange={(event) => setWilcoxonMetric(event.target.value)}
                    >
                        <MenuItem value={"si_sdr"} style={{ display: "block" }}>SI-SDR</MenuItem>
                        <MenuItem value={"speech_signal_consolidation_score"} style={{ display: "block" }}>Speech Signal Conslidation Score</MenuItem>
                    </Select>
                </FormControl>}                
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginTop: '20px', marginRight: '20px' }}>
                    <InputLabel id="comparative_set_id">Persister Config ID</InputLabel>
                    <Select
                        id="persister_config_id"
                        label="Persister Config ID"
                        value={persisterConfigID}
                        variant="outlined"
                        onChange={(event) => setPersisterConfigID(event.target.value)}
                    >
                        {persisterConfigOptions.map(x => <MenuItem value={x["id"]} style={{ display: "block" }}>{x["id"]}</MenuItem>) }
                        {/*<MenuItem value={"Channel_Resonator_Waveforms_Only"} style={{ display: "block" }}>Channel_Resonator_Waveforms_Only</MenuItem>*/}
                        {/*<MenuItem value={"Speech_Signal_Absorption_Time_Series"} style={{ display: "block" }}>Speech_Signal_Absorption_Time_Series</MenuItem>*/}
                        {/*<MenuItem value={"More_Harmonics_Speech_Signal_Absorption_Time_Series"} style={{ display: "block" }}>More_Harmonics_Speech_Signal_Absorption_Time_Series</MenuItem>*/}
                    </Select>
                </FormControl>
                <FormControl style={{ width: '45%', marginTop: '20px' }}>
                    <TextField
                        label="Max Generation Count"
                        onChange={(event) => setMaxGenerationCount(event.target.value)}
                        required
                        value={maxGenerationCount}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ m: 2, height: '10px', }}>
                <Box style={{ width: '48%', height: '10px', display: 'inline-block', float: 'left' }}>
                    <Box sx={{ m: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" href={"gen-alg-runs"}>Cancel</Button>
                            <Button variant="outlined" onClick={() => createGenAlgRun()} disabled={isSubmitButtonDisabled}>Submit</Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateGenAlgRun;
